import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "@atoms";

import { IProps } from "@atoms/SimplTooltipModal/types";

const SimplTooltipModal: React.FC<IProps> = (
  {
    show, onHide
  }: IProps) => {
  return (
    <div>
      <Modal show={show} onHide={onHide} size={"sm"}>
        <Modal.Body>
          <img width={"100%"} src={"https://cdn.getsimpl.com/images/pay_in_3/interstitial_1.jpg"} />
        </Modal.Body>
        <Modal.Footer style={{justifyContent: "center"}}>
          <Button onClick={onHide} color="primary">close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
};

export { SimplTooltipModal }